import { createFileRoute } from '@tanstack/react-router'

import { Cards } from '~/boundedContext/cards/pages/cards'

export const Route = createFileRoute('/_main-layout/cards/')({
  component: Cards,
})
